import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'ServiceUnavailable.title',
    defaultMessage: 'Service unavailable',
    description: 'Title text indicating the page is temporarily unavailable',
  },
  description: {
    id: 'ServiceUnavailable.description',
    defaultMessage: 'This page is temporarily unavailable. Please try again later.',
    description: 'Description text explaining the page is temporarily unavailable',
  },
});
